import IAsset from "../../models/IAsset";
import { ASSET_TYPE_ID } from "../../const";

import ImageAssetPreview from "./components/ImageAssetPreview";
import AudioAssetPreview from "./components/AudioAssetPreview";
import VideoAssetPreview from "./components/VideoAssetPreview";
import PdfAssetPreview from "./components/PdfAssetPreview";

import styles from "./assetReplacePreview.module.css";
import GenericAssetPreview from "./components/GenericAssetPreview";
import SmartObjectAssetPreview from "./components/SmartObjectAssetPreview";
import SmartObjectDetails from "./components/SmartObjectDetails";

interface AssetReplacePreviewProps {
  sourceAsset?: IAsset;
  newAsset?: IAsset;
}
export default function AssetReplacePreview({ sourceAsset, newAsset }: Readonly<AssetReplacePreviewProps>) {
  /**
   * Conditional rendering based on asset type
   */

  function renderAssetPreview(asset?: IAsset) {
    if (!asset) return null;
    switch (asset.assetTypeId) {
      case ASSET_TYPE_ID.IMAGE:
      case ASSET_TYPE_ID.PANORAMIC_IMAGE:
        return <ImageAssetPreview asset={asset} />;
      case ASSET_TYPE_ID.AUDIO:
      case ASSET_TYPE_ID.AUDIO_EFFECT:
        return <AudioAssetPreview asset={asset} />;
      case ASSET_TYPE_ID.VIDEO:
        return <VideoAssetPreview asset={asset} />;
      case ASSET_TYPE_ID.PDF:
        return <PdfAssetPreview asset={asset} />;
      case ASSET_TYPE_ID.SMART_OBJECT:
        return <SmartObjectAssetPreview data={asset} />;
      default:
        return <GenericAssetPreview asset={asset} />;
    }
  }

  function renderAssetComparisonDetails(sourceAsset?: IAsset, newAsset?: IAsset) {
    if (!sourceAsset || !newAsset) return null;
    switch (sourceAsset.assetTypeId) {
      case ASSET_TYPE_ID.SMART_OBJECT:
        return <SmartObjectDetails sourceAsset={sourceAsset} newAsset={newAsset} />;
      default:
        return null;
    }
  }

  return (
    <>
      <div className={styles.assetComparison}>
        <div aria-label="Source Asset">
          <input type="text" value={`Version Notes: ${sourceAsset?.versionNotes ?? "N/A"}`} disabled />
          {renderAssetPreview(sourceAsset)}
        </div>
        <div aria-label="New Asset">
          <input type="text" value={`Version Notes: ${newAsset?.versionNotes ?? "N/A"}`} disabled />
          {renderAssetPreview(newAsset)}
        </div>
      </div>
      <div className={styles.assetComparisonDetails}>{renderAssetComparisonDetails(sourceAsset, newAsset)}</div>
    </>
  );
}
